<div class="wrapper">
	<div
		#wrapperArticles
		(scroll)="onScroll()"
		[class.show-list]="showFirstArticles || !showAllButton"
		[class.vertical]="isVertical"
		class="wrapper-articles"
	>
		@for (optionArticle of optionGroupValue.articles; track optionArticle) {
			@if (!ifFilterVisible(optionArticle)) {
				@if (!isHidden(optionArticle)) {
					<ion-card
						(click)="count(optionArticle) === 0 && onAdd(optionArticle)"
						[class.selected]="count(optionArticle) > 0"
						class="item-card"
					>
						<ion-card-header>
							@if ((optionArticle.info | langObservable | async)?.length > 0) {
								<ion-icon
									(click)="openInfoEmit(optionArticle); $event.stopPropagation()"
									class="info-icon"
									src="/assets/topgolf/info.svg"
								></ion-icon>
							}
							@if (count(optionArticle) > 0) {
								<div class="spacer"></div>
								<ion-icon class="selected-icon" src="/assets/topgolf/selected.svg"></ion-icon>
							}
						</ion-card-header>
						<ion-card-content>
							@if (optionArticle.assets.large) {
								<div class="item-image-wrapper">
									<ion-img [src]="optionArticle.assets.large" class="item-image"></ion-img>
								</div>
							}
							<ion-card-title class="item-name">{{ optionArticle.name | langObservable | async }}</ion-card-title>
							@if (getArticlePrice(optionArticle) > 0) {
								<p class="item-price">+{{ numberToCurrency(getArticlePrice(optionArticle), currency) }}</p>
							} @else {
								<p class="item-price item-price-zero">&nbsp;</p>
							}
							<div class="card-footer">
								@if (count(optionArticle) === 0) {
									<ion-icon
										(click)="onAdd(optionArticle); $event.stopPropagation()"
										class="add-icon"
										src="/assets/icon/plus.svg"
									></ion-icon>
								} @else {
									<div class="quantity-selector">
										<ion-icon
											(click)="onRemove(optionArticle); $event.stopPropagation()"
											class="quantity-btn"
											src="/assets/icon/minus.svg"
										></ion-icon>
										<span class="quantity-text">{{ count(optionArticle) }}</span>
										<ion-icon
											(click)="onAdd(optionArticle); $event.stopPropagation()"
											class="quantity-btn"
											src="/assets/icon/plus.svg"
										></ion-icon>
									</div>
								}
							</div>
						</ion-card-content>
					</ion-card>
				}
			}
		}
	</div>
</div>
